document.addEventListener('DOMContentLoaded', () => {
    if ($(window).width() > 1101) {
      $(window).scroll(function () {
        if ($(window).scrollTop() + ($(window).height() * 2) / 3 > $('.aph320-left-image-right-text').offset().top) {
          $('.aph320-left-image-right-text').addClass('animate-text');
        } else {
          $('.aph320-left-image-right-text').removeClass('animate-text');
        }
      });
    }
  });